import ApiService from './ApiService';

class DevelopmentsService {
  static async getDevelopmentsFilters() {
    const composedURL = `/api3/development/filters`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getDevelopmentsList(queryParams) {
    let composedURL = `/api3/development/filter_by_criteria`;
    if (queryParams) {
      const queryString = new URLSearchParams(queryParams).toString();
      composedURL += `?${queryString}`;
    }
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getCompanyDevelopments(searchword = '') {
    let composedURL = `/api3/developments`;
    if (searchword) {
      composedURL += `?searchword=${encodeURIComponent(searchword)}`;
    }
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getCompanyIntegrationsStatus() {
    const composedURL = `/api3/company/integrations/status`;
    const response = await ApiService.get(composedURL);
    return response;
  }
}

export default DevelopmentsService;
